import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 2500);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <div className="relative h-screen bg-[#E31837] flex flex-col items-center justify-center px-6">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 flex flex-col items-center">
        <div className="mb-8 animate-pulse">
          <img 
            src="https://public.readdy.ai/ai/img_res/92163c45-d441-4eec-8f6b-13c08dfd0d13.png" 
            alt="Domino's Logo" 
            className="w-32 h-32 object-contain"
          />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-2">Domino's Courier</h1>
        <p className="text-white/90 text-base">Snabb leverans, varje gång</p>
        
        <div className="mt-12 flex items-center gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>
    </div>
  );
}
